import AuthService from './AuthService';

class PlanService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
        this.plansPath = '/admin/plans';
    }

    getAuthHeaders(extraHeaders) {
        const token = AuthService.getAccessToken();
        const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
        return {
            ...authHeader,
            ...(extraHeaders || {}),
        };
    }

    async getPlans() {
        const url = `${this.apiBaseUrl}${this.plansPath}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async createPlan(payload) {
        const url = `${this.apiBaseUrl}${this.plansPath}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(payload || {}),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async updatePlan(planId, payload) {
        if (!planId) throw new Error('planId is required');
        const url = `${this.apiBaseUrl}${this.plansPath}/${encodeURIComponent(planId)}`;
        const response = await fetch(url, {
            method: 'PUT',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(payload || {}),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async deletePlan(planId) {
        if (!planId) throw new Error('planId is required');
        const url = `${this.apiBaseUrl}${this.plansPath}/${encodeURIComponent(planId)}`;
        const response = await fetch(url, {
            method: 'DELETE',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Some APIs return JSON, some return empty.
        const text = await response.text();
        try {
            return text ? JSON.parse(text) : { ok: true };
        } catch {
            return { ok: true };
        }
    }

    async getPlan(planId) {
        if (!planId) throw new Error('planId is required');
        const url = `${this.apiBaseUrl}${this.plansPath}/${encodeURIComponent(planId)}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }
}

const planService = new PlanService();
export { PlanService };
export default planService;
